export const title = 'District M'
export const version = 'v0.1'
